export function getSkillTranslation(name, t){
  return t(name, {ns:'skills'})
}